import { TitleCasePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from '@environments/environment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  public title$: Observable<string>;
  public showEmailButton$: Observable<boolean>;
  public showExpandCollapseAllButtons$: Observable<boolean>;
  public setAllPanelOpenStates$: Observable<boolean>;
  
  private titleSubject: BehaviorSubject<string>;
  private showEmailButtonSub: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private showExpandCollapseAllSub: BehaviorSubject<boolean>= new BehaviorSubject(false);
  private setAllPanelOpenStates: Subject<boolean> = new Subject<boolean>();
  private readonly appTitle: string = environment.installBanner.length > 0
    ? 'Stiira ' + environment.installBanner
    : 'Stiira';

  constructor(
    private titleService: Title,
    private titleCasePipe: TitleCasePipe
  ) {
    this.showEmailButton$ = this.showEmailButtonSub.asObservable();
    this.showExpandCollapseAllButtons$ = this.showExpandCollapseAllSub.asObservable();
    this.setAllPanelOpenStates$ = this.setAllPanelOpenStates.asObservable();
    this.titleSubject = new BehaviorSubject('');
    this.title$ = this.titleSubject.asObservable();
  }

  public setTitle(title: string): void {
    this.titleSubject.next(title);
    this.setPageTitle(title);
  }

  // sets only the browser tab title; pages that show the header should call setTitle() instead, which calls this too
  public setPageTitle(title: string): void {
    this.titleService.setTitle(title
      ? this.titleCasePipe.transform(title) + ' - ' + this.appTitle
      : this.appTitle);
  }

  public showEmailButton(show: boolean): void {
    this.showEmailButtonSub.next(show);
  }

  public showExpandCollapseAllButton(show: boolean): void {
    this.showExpandCollapseAllSub.next(show);
  }

  public onExpandAll(): void {
    this.setAllPanelOpenStates.next(true);
  }

  public onCollapseAll(): void {
    this.setAllPanelOpenStates.next(false);
  }
}